$(document).ready(function() {
  function extractVariantFromUrl() {
    var currentUrl = window.location.href;
    var variantNumberMatch = currentUrl.match(/variant=([0-9]+)/);
    if (variantNumberMatch) {
      var variantNumber = variantNumberMatch[1];
      var current_var_qty = $(`.m-product-option--variant.hidden[variant-id="${variantNumber}"]`).attr('variant-qty');
      var percentage = (  parseInt(current_var_qty) * 5 );
      $('.main-product__block .foxkit-stock-countdown__progress').css('width', percentage > 99 ? 100 : percentage +'%');
    } else {
      console.log('Variant number not found in the URL');
    }
  }

  // Initial check on document ready
  extractVariantFromUrl();

  // Detect URL changes through popstate event (back/forward navigation)
  window.addEventListener('popstate', function(event) {
    extractVariantFromUrl();
  });

  // MutationObserver to detect changes in the URL
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'href') {
        extractVariantFromUrl();
      }
    });
  });

  // Observe the URL changes
  observer.observe(document.querySelector('body'), {
    attributes: true,
    subtree: true,
    attributeFilter: ['href']
  });

  // Override pushState and replaceState to detect URL changes
  var pushState = history.pushState;
  history.pushState = function() {
    pushState.apply(history, arguments);
    extractVariantFromUrl();
  };

  var replaceState = history.replaceState;
  history.replaceState = function() {
    replaceState.apply(history, arguments);
    extractVariantFromUrl();
  };

  document.addEventListener('contextmenu', function(e) {
      // e.preventDefault();
  });
  
  document.addEventListener('touchstart', function(e) {
      if (e.target.nodeName === 'IMG') {
          e.preventDefault();
      }
  });


  document.addEventListener('keydown', function(event) {
      if (event.key === 'F12' || (event.ctrlKey && event.shiftKey && event.key === 'I')) {
          event.preventDefault();
          event.stopPropagation();
          return false;
      }
  });
  
    $('img').on('dragstart', function(event) {
      event.preventDefault();
    });

});






